import type { CbiFrontendServiceContext } from "../../frontend/context/CbiFrontendServiceContext";
import type { PersonPersonTypeDTOBase } from "./PersonPersonTypeDTOBase";
import type { PersonStaff } from "./PersonStaff";
import type { PersonTypeRef } from "./PersonTypeRef";
import type { PersonTypeStaff } from "./PersonTypeStaff";
import type { TrackedBase } from "./TrackedBase";

export class PersonPersonTypeStaff implements PersonPersonTypeDTOBase, TrackedBase {
  constructor(public readonly assignId: number, public readonly personId: PersonStaff | null, public readonly typeId: PersonTypeStaff, public readonly createdOn: Date | null, public readonly createdBy: string | null, public readonly updatedOn: Date | null, public readonly updatedBy: string | null, public readonly typeIdTargetIds: PersonTypeRef) {
    this.cbiServiceContext = null;
    this.personIdLoaded = this.personId != null;
    this.personIdCached = this.personId;
  }
  cbiServiceContext: CbiFrontendServiceContext | null;
  private personIdLoaded: boolean;
  private personIdCached: PersonStaff | null;
  async personIdLazy(): Promise<PersonStaff> {
    if (!this.personIdLoaded) {
      this.personIdCached = await this.cbiServiceContext!.personService().getPersonPersonTypeStaffPersonId(this.assignId);
      this.personIdLoaded = true;
    }
    return this.personIdCached!;
  }
}
